<div class="search-display-container">
  <ng-template #mapContainer></ng-template>
</div>
